module.exports = __webpack_public_path__ + "static/media/SAFIR 9 TONEARM.2c2da29f.png";